import { Component } from "@angular/core";

@Component({
  selector: "app-desktop",
  template: ` <app-d-landing-page></app-d-landing-page> `,
  styles: [],
})
export class DesktopComponent {}
